import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactQuill from 'react-quill'; 
import 'react-quill/dist/quill.snow.css';
import { Button, Card, CardBody,CardTitle } from 'reactstrap'
import Dropzone from 'react-dropzone';
import {postNews} from '../../actions/contentsActions'
import Input from '../common/inputComponent'

const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 16
};

const thumb = {
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: 'border-box'
};

const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden'
};

const img = {
  display: 'block',
  width: 'auto',
  height: '100%'
};


 class newContent extends Component {
  constructor(props) {
    super(props)
    this.state = { 
      text: '' ,
      Title:"",
      Description:"",
      files:[]} // You can also pass a Quill Delta here
    this.handleChange = this.handleChange.bind(this)
    this._onSubmit = this._onSubmit.bind(this)
    this._onDrop = this._onDrop.bind(this)
    this._onChange = this._onChange.bind(this)
  }

  handleChange(value) {
    this.setState({ text: value })
  }
  _onSubmit(e){
    e.preventDefault()
    let formdata = new FormData()
    formdata.append("Contents",this.state.text)
    formdata.append('Title',this.state.Title)
    this.state.files.map(file => {
      formdata.append("Image",file)
    })
    this.props.postNews(formdata)
  }
  _onDrop=(files)=>{
    this.setState({files:files.map(file => Object.assign(file, {
      preview: URL.createObjectURL(file)
    }))})
  }
  _onChange(e){
    this.setState({[e.target.name]:e.target.value})
  }
  render() {
    const thumbs = this.state.files.map(file => (
      <div style={thumb} key={file.name}>
        <div style={thumbInner}>
          <img
            src={file.preview}
            style={img}
          />
        </div>
      </div>
    ));
    return (
      <div className="main-content">
        <Card>
          <CardTitle>
            Đăng bài viết mới
          </CardTitle>
          <CardBody>
            <form onSubmit={this._onSubmit} enctype="multipart/form-data">
              <Input name="Title" placeholder="Tiêu đề thông báo" value={this.state.Title} onChange={this._onChange}/>
              <hr/>
              <ReactQuill theme="snow" value={this.state.text} onChange={this.handleChange} />
              <br/>
              <Dropzone accept='image/*' onDrop={this._onDrop} >
              {({getRootProps, getInputProps}) => (
                <section className="container">
                  <div {...getRootProps({className: 'dropzone'})}>
                    <input {...getInputProps()} />
                    <p>Drag 'n' drop some files here, or click to select files</p>
                  </div>
                  <aside style={thumbsContainer}>
                    {thumbs}
                  </aside>
                </section>
              )}
              </Dropzone>
              <Button>Đăng bài viết</Button>
            </form>
          </CardBody>
        </Card>
        
      </div>
      
    )
  }
}

newContent.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default  connect(mapStateToProps,{postNews})(newContent)


// WEBPACK FOOTER //
// ./src/components/pages/newContent.js